import React from "react";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import WhiteExes from "../../assets/icons/white-exes-animated.gif";
import StaticCover from "../../assets/images/static-cover.gif";
import contestIcons from "../../assets/icons/bzrp-cont-icons.png";
import BzrpMainImg from "../../assets/images/biza-main-img.gif";
import BzrpDiscord from "../../assets/images/bzrp-discord.png";
import ContestIcons from "../../assets/icons/bzrp-cont-icons.png";
import ChooseMainImg from "../../assets/images/choose-section-img.png";

const sxStyles = {
  mainContainer: {
    backgroundColor: "black",
    display: "flex",
    justifyContent: "center",
    flexGrow: 1,
    overflow: "hidden",
    position: "relative",
    height: "700px",
  },
  staticCover: {
    backgroundSize: "cover",
    display: "flex",
    justifyContent: "center",
    flexGrow: 1,
    overflow: "hidden",
  },
  content: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: "flex-start",
    justifyContent: "flex-end",
    width: "1440px",
    boxSizing: "border-box",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left",
    paddingTop: { xs: "70px", md: "100px" },
  },
  sectionText: {
    color: "white",
    fontSize: { xs: "16px", md: "24px" },
    fontFamily: "IBM Plex Sans",
    fontWeight: "400",
    lineHeight: { xs: "24px", md: "34px" },
    textAlign: "left",
    maxWidth: { xs: "355px", md: "100%" },
    paddingLeft: { xs: "20px", md: 0 },
  },
  p2Title: {
    color: "#FDD925",
    fontFamily: "p22-arts-and-crafts",
    fontSize: { xs: "22px", md: "30px" },
    fontWeight: "700",
    lineHeight: { xs: "24px", md: "32px" },
    marginRight: "13px",
  },
  title: {
    color: "#FDD925",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "22px", md: "30px" },
    fontWeight: "400",
    lineHeight: { xs: "24px", md: "32px" },
    marginRight: "13px",
  },
  secondTitle: {
    color: "#FDD925",
    fontFamily: "IBM Plex Sans",
    fontSize: { xs: "35px", md: "64px" },
    fontWeight: "700",
    lineHeight: { xs: "35px", md: "65px" },
    marginRight: "13px",
    marginBottom: "32px",
  },
};

const DiscordSection = () => {
  return (
    <Grid sx={sxStyles.staticCover}>
      <Box
        sx={{
          height: { xs: "700px", md: "600px", xl: "700px" },
          width: { xs: "375px", md: "1440px", xl: "1920px" },
          position: "absolute",
          backgroundImage: `url(${StaticCover})`,
          opacity: "15%",
          zIndex: "1",
        }}
      />
      <Grid sx={sxStyles.mainContainer}>
        <Grid sx={sxStyles.content}>
          <Box
            sx={{
              width: { xs: "650px", md: "750px" },
              height: "750px",
              background: {
                xs: `url(${BzrpMainImg})`,
              },
              backgroundPosition: { xs: "left top", md: "center center" },
              backgroundSize: { xs: "cover", md: "cover" },
              backgroundRepeat: "no-repeat",
              position: { xs: "absolute", md: "relative" },
              top: { xs: "40px", md: "0px" },
              left: { xs: "-330px", md: "unset" },
              right: { xs: 0, md: "unset" },
              opacity: { xs: "60%", md: "100%" },
            }}
          />
          <Stack
            sx={{
              position: "relative",
            }}
          >
            <Box
              sx={{
                height: "70px",
                display: "flex",
                backgroundImage: `url(${ContestIcons})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                width: { xs: "280px", md: "400px" },
                alignSelf: "center",
                paddingBottom: { xs: "0px", md: 0 },
              }}
            />
            <Stack
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: { xs: "350px", md: "800px" },
                marginBottom: "60px",
              }}
            >
              <Grid
                sx={{
                  display: { xs: "none", md: "flex" },
                  marginTop: "20px",
                  justifyContent: { xs: "center", md: "flex-start" },
                }}
              >
                <Typography sx={sxStyles.title}>UNITE AL </Typography>
                <Typography sx={sxStyles.p2Title}>DISCORD </Typography>
                <Typography sx={sxStyles.title}>
                  PARA INTERCAMBIAR TUS{" "}
                </Typography>
              </Grid>
              <Grid
                sx={{
                  display: { xs: "flex", md: "none" },
                  marginTop: "20px",
                  justifyContent: { xs: "center", md: "left" },
                }}
              >
                <Typography sx={sxStyles.title}>UNITE AL </Typography>
                <Typography sx={sxStyles.p2Title}>DISCORD </Typography>
              </Grid>
              <Box sx={{ display: { xs: "flex", md: "none" } }}>
                <Typography sx={sxStyles.title}>PARA INTERCAMBIAR</Typography>
              </Box>
              <Stack
                sx={{
                  display: { xs: "flex", md: "none" },
                  justifyContent: { xs: "center", md: "left" },
                  marginBottom: "20px",
                }}
              >
                <Typography sx={sxStyles.title}>
                  TUS CARDS REPETIDAS,
                </Typography>
                <Grid
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <Typography sx={sxStyles.title}>GANAR</Typography>
                  <Typography sx={sxStyles.p2Title}>CÓDIGOS </Typography>
                </Grid>
                <Typography sx={sxStyles.p2Title}>PROMOCIONALES </Typography>
                <Typography sx={sxStyles.title}>TODOS LOS DÍAS Y</Typography>
                <Typography sx={sxStyles.title}>COMPLETAR EL ÁLBUM</Typography>
                <Typography sx={sxStyles.title}>MÁS RÁPIDO!</Typography>
              </Stack>
              <Grid
                sx={{
                  display: { xs: "none", md: "flex" },
                  marginTop: "20px",
                  justifyContent: { xs: "center", md: "left" },
                  alignItems: { xs: "center", md: "flex-start" },
                  marginBottom: "20px",
                }}
              >
                <Typography sx={sxStyles.title}>
                  CARDS REPETIDAS, GANAR
                </Typography>
                <Typography
                  sx={{
                    color: "#FDD925",
                    fontFamily: "p22-arts-and-crafts",
                    fontSize: { xs: "22px", md: "30px" },
                    fontWeight: "700",
                    lineHeight: { xs: "24px", md: "32px" },
                    marginRight: "13px",
                    paddingRight: "130px",
                  }}
                >
                  CÓDIGOS{" "}
                </Typography>
              </Grid>
              <Grid
                sx={{
                  display: { xs: "none", md: "flex" },
                  justifyContent: { xs: "center", md: "left" },
                  marginBottom: "20px",
                }}
              >
                <Typography
                  sx={{
                    color: "#FDD925",
                    fontFamily: "p22-arts-and-crafts",
                    fontSize: { xs: "22px", md: "30px" },
                    fontWeight: "700",
                    lineHeight: { xs: "24px", md: "32px" },
                    marginRight: "13px",
                    paddingLeft: "60px",
                  }}
                >
                  PROMOCIONALES{" "}
                </Typography>
                <Typography sx={sxStyles.title}>
                  TODOS LOS DÍAS Y COMPLETAR
                </Typography>
              </Grid>
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <Typography
                  sx={{
                    color: "#FDD925",
                    fontFamily: "IBM Plex Sans",
                    fontSize: { xs: "22px", md: "30px" },
                    fontWeight: "400",
                    lineHeight: { xs: "24px", md: "32px" },
                    marginRight: "335px",
                    textAlign: "left",
                  }}
                >
                  EL ÁLBUM MAS RÁPIDO!
                </Typography>
              </Box>
            </Stack>
            <Button
              href={"https://discord.gg/TGF6yEMgkK"}
              target={"_blank"}
              sx={{
                zIndex: 1,
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
            >
              <Box
                sx={{
                  height: "155px",
                  display: "flex",
                  backgroundImage: `url(${BzrpDiscord})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  width: "185px",
                  alignSelf: "center",
                  paddingBottom: "70px",
                }}
              />
            </Button>
          </Stack>
        </Grid>
        <Box
          sx={{
            width: "450px",
            height: "90px",
            position: "absolute",
            zIndex: 1,
            left: { xs: "10px", md: "100px", xl: "320px" },
            top: { xs: "75px", md: "420px" },
            display: { xs: "none", md: "flex" },
          }}
        >
          <img
            src={WhiteExes}
            style={{ width: "450px", height: "80px" }}
            alt={""}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default DiscordSection;
